


































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { userType } from '@/app/model/store/domain/const'

@Component({
  components: {
    PageTitle
  }
})
export default class NewsBoardSearch extends Vue {
  private year: number = this.$store.state.newsBoardState.selectedYear
  private search: string = this.$store.state.newsBoardState.searchText
  private yearList: number[] = []
  private newsBoardTitle: string = ''
  private newsBoardSearchPlaceHolder: string = ''
  private isAdmin: boolean = false

  @Prop() private newsBoardCount!: number
  @Prop() private newsBoardContentCount!: number

  created () {
    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.newsBoardSearchPlaceHolder = this.newsBoardTitle + '名、分類、品種、地区、記事タイトルで検索'

    if (Local.getUserType() === String(userType.USER_TYPE_ADMIN)) {
      this.isAdmin = true
    }

    /* yearの配列を作成 */
    const endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    if (this.$store.state.newsBoardState.selectedYear === 0) {
      this.year = new Date().getFullYear()
    } else {
      this.year = this.$store.state.newsBoardState.selectedYear
    }
  }

  private doSearch () {
    this.$store.commit('newsBoardState/setSearchText', this.search)
    this.$store.commit('newsBoardState/setSelectedYear', this.year)
    this.$emit('search-list')
  }

  private doClear () {
    this.search = ''
    this.year = new Date().getFullYear()
    this.$store.commit('newsBoardState/setSearchText', this.search)
    this.$store.commit('newsBoardState/setSelectedYear', this.year)
    this.$emit('search-list')
  }
}
